// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const WarningFill = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 16}
    height={size ?? 16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.786 2.335c.65-.836 1.998-.776 2.548.18l5.465 9.49.001.002c.585 1.02-.183 2.243-1.334 2.243H2.534c-1.151 0-1.92-1.223-1.335-2.243v-.001l5.467-9.491zM8 10.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-.5-1h1v-3.5h-1z"
    />
  </svg>
);
const ForwardRef = forwardRef(WarningFill);
export default ForwardRef;
